module.exports = __webpack_public_path__ + "../resources/images/laugh-f6bd671d42472e560299e20b7cc49b41.svg";